


export const TaskIconOptions  = [

    [
        'task',
        'idea',
        'question',
        'bug',

        'beer',
        'book',
        'briefcase',
        'social_broadcast',

        'upload',
        'download',


        'device_mobile',
        'device_desktop',

        'phone',
        'money',

        'device_video',
        'device_camera',
        'database',
        'file_binary',
        'file_code',
        'file_contact',
        'file_text',
        'flame',
        'globe',
        'gift',
        'dev_gist',
        'graph',
        'law',
        'key',
        'link',
        'location',
        'mail',
        'mail_read',
        'mention',
        'milestone',
        'study',
        'pulse',
        'social_rss',
        'search',
        'squirrel',
        'steps',
        'telescope',
        'tools',
        'contact',
        'anchor',
        'bookmark',
        'burst',
        'first_aid',
        'paint_bucket',
        'quote',
        'social_youtube',
        'trophy',
        'shield',
        'shopping_cart',
        'rocket',
        'brush',
        'bucket',
        'social_twitter',
        'userSearch',
        'megaphone',
    ]

];